module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Shop Item Page"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Shop Item")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticClass: "heading-cart cf"
  }, [_c('h1', [_vm._v("My Cart")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continue Shopping")])]), _vm._v(" "), _c('ul', {
    staticClass: "cart-items width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid"
  }, [_c('li', {
    staticClass: "cart-items-labels visible-lg-block visible-md-block row"
  }, [_c('span', {
    staticClass: "col-md-6 text-muted small"
  }, [_vm._v("product")]), _vm._v(" "), _c('span', {
    staticClass: "col-md-2 text-muted small text-center"
  }, [_vm._v("quantity")]), _vm._v(" "), _c('span', {
    staticClass: "col-md-4 text-muted small text-right"
  }, [_vm._v("price")])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "product description",
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "cart-description col-xs-12 col-md-5"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")]), _vm._v(" "), _c('span', {
    staticClass: "cart-item-price h5 text-muted"
  }, [_vm._v("$ 33.00")])]), _vm._v(" "), _c('span', {
    staticClass: "col-md-2 col-sm-12"
  }, [_c('input', {
    staticClass: "text-center form-control",
    attrs: {
      "type": "text",
      "value": "10"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "col-md-5 col-sm-12 text-right"
  }, [_c('span', {
    staticClass: "cart-price pull-right"
  }, [_vm._v("$330.00 "), _c('a', {
    staticClass: "cart-remove",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-trash icon pull-right mt-5 ml-10"
  })])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "product description",
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "cart-description col-xs-12 col-md-5"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")]), _vm._v(" "), _c('span', {
    staticClass: "cart-item-price h5 text-muted"
  }, [_vm._v("$ 33.00")])]), _vm._v(" "), _c('span', {
    staticClass: "col-md-2 col-sm-12"
  }, [_c('input', {
    staticClass: "text-center form-control",
    attrs: {
      "type": "text",
      "value": "10"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "col-md-5 col-sm-12 text-right"
  }, [_c('span', {
    staticClass: "cart-price pull-right"
  }, [_vm._v("$330.00 "), _c('a', {
    staticClass: "cart-remove",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-trash icon pull-right mt-5 ml-10"
  })])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "alt": "product description",
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "cart-description col-xs-12 col-md-5"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")]), _vm._v(" "), _c('span', {
    staticClass: "cart-item-price h5 text-muted"
  }, [_vm._v("$ 33.00")])]), _vm._v(" "), _c('span', {
    staticClass: "col-md-2 col-sm-12"
  }, [_c('input', {
    staticClass: "text-center form-control",
    attrs: {
      "type": "text",
      "value": "10"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "col-md-5 col-sm-12 text-right"
  }, [_c('span', {
    staticClass: "cart-price pull-right"
  }, [_vm._v("$330.00 "), _c('a', {
    staticClass: "cart-remove",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-trash icon pull-right mt-5 ml-10"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "width-100 pr-45 checkout-devin"
  }, [_c('ul', [_c('li', {
    staticClass: "totalRow"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Subtotal")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("$35.00")])]), _vm._v(" "), _c('li', {
    staticClass: "totalRow"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Shipping")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("$5.00")])]), _vm._v(" "), _c('li', {
    staticClass: "totalRow"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Tax")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("$4.00")])]), _vm._v(" "), _c('li', {
    staticClass: "totalRow final"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Total")]), _c('span', {
    staticClass: "value"
  }, [_vm._v("$44.00")])]), _vm._v(" "), _c('li', {
    staticClass: "totalRow"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Checkout")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f6b12cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ShopItem.vue
// module id = 1383
// module chunks = 2